export default __webpack_public_path__ + "static/media/carousel-img-1.e978610d.webp";